/* eslint-disable */
import React, { useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { IconEyeOff, IconEyeOn } from 'modules/common/components/Icons';
import PropTypes from 'prop-types';
// import { ModalContext } from 'App';
// import Logo from 'assets/img/logo-white.png';
import InputMask from 'react-input-mask';
import imagePhone from 'assets/img/img-phone.png';
import APP_VERSION from 'version';
import * as actions from '../actions';
import * as c from '../constants';
import MiniLoader from '../../common/components/MiniLoader';
import CmsContext from '../../../context/CmsContext';

const form = {
  email: '',
  password: '',
  password_confirmation: '',
};

const demoData = JSON.parse(localStorage.getItem('demoData'));

function ResetPassword({
  isLoading,
  resetPassword,
  mfaLogin,
  history,
  location,
}) {
  const parseItem = _.get(location, 'search').split('&');
  const token = parseItem[1].split('=')[1];
  const emails = parseItem[0].split('=')[1];

  const cmsContext = useContext(CmsContext);

  const [enable2fa, setEnable2fa] = useState('');

  const [hidden, setHidden] = useState({ hidden: false });
  const [formData, setFormData] = useState(form);

  // const CMS_COLORS = cmsContext.findByType('COLORS');
  const CMS_LOGO = cmsContext.findByType('LOGOS');
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');

  const cmsLogo = _.get(CMS_LOGO, 'CORE_LOGO.cdnUrl');
  const cmsLogoWhite = _.get(CMS_LOGO, 'CORE_LOGO_WHITE.cdnUrl');

  const displayLogoImage = !_.isEmpty(CMS_LOGO) ? (
    <img
      src={!cmsLogoWhite ? cmsLogoWhite : cmsLogo}
      className="front-icon-logo"
      alt="Local Government System"
    />
  ) : (
    <MiniLoader />
  );

  const handleOnChange = (e) => {
    e.preventDefault();
    setFormData({
      ...formData,
      email: token,
      token: emails,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogin = (e) => {
    e.preventDefault();

    resetPassword(formData, () => {
      history.push('/');
    });
  };

  return (
    <div className="login-page login-core login-background--core">
      <div className="container h-100">
        <div className="row h-100 d-flex align-items-center justify-content-center">
          <div className="col-md-12 mx-auto">
            <div className="login-section">
              <div className="mb-4">
                {!_.isEmpty(demoData) ? (
                  <img
                    src={demoData.image_url}
                    alt="Local Government System"
                    style={{
                      width: 'auto',
                      height: `${demoData.height}px`,
                      fill: '#ffffff',
                    }}
                  />
                ) : (
                  displayLogoImage
                )}
              </div>
              <div className="content">
                {enable2fa === '' && (
                  // <div className="login-box">
                  <div className="login-box-smart-city">
                    <div className="d-flex mx-auto mb-3">
                      <div className="mr-2">
                        <img
                          src={
                            _.get(CMS_LOGO, 'LOGO.cdnUrl') ||
                            _.get(CMS_LOGO, 'LOGO')
                          }
                          alt=""
                          width={64}
                          height={64}
                        />
                      </div>
                      <div className="mt-2">
                        <h3 className="font-weight-bold mb-0">  
                          {_.get(CMS_VARIABLES, 'ALTERNATE_MUNICIPALITY_NAME') 
                            ? _.get(CMS_VARIABLES, 'ALTERNATE_MUNICIPALITY_NAME') 
                            : _.get(CMS_VARIABLES, 'MUNICIPALITY_NAME')}
                        </h3>
                        <div className="text-sm">
                          {_.get(CMS_VARIABLES, 'ALTERNATE_PROVINCE_NAME') 
                            ? _.get(CMS_VARIABLES, 'ALTERNATE_PROVINCE_NAME') 
                            : _.get(CMS_VARIABLES, 'PROVINCE_NAME')}
                        </div>
                      </div>
                    </div>
                    <div className="welcome-intro">
                      <h4 className="title-smart-city cms-text-secondary">
                        Reset Password
                      </h4>
                    </div>
                    <form onSubmit={handleLogin} className="login-form">
                      <div className="form-group">
                        <label
                          htmlFor="password"
                          className="form-label-smart-city"
                        >
                          New Password
                        </label>
                        <div className="inner-addon right-addon right-addon-button">
                          <input
                            type={hidden ? 'password' : 'text'}
                            placeholder="New Password"
                            onChange={handleOnChange}
                            value={_.get(formData, 'password') || ''}
                            name="password"
                            id="loginPassword"
                            className="form-control form-control-lg form-control-icon"
                            style={{
                              border: '1px solid #D3D3D3',
                              borderRadius: '8px',
                            }} // smart-city
                          />
                          <button
                            type="button"
                            tabIndex={-1}
                            className="btn btn-right"
                            onClick={() => setHidden(!hidden)}
                          >
                            {hidden ? <IconEyeOn /> : <IconEyeOff />}
                          </button>
                        </div>
                      </div>
                      <div className="form-group">
                        <label
                          htmlFor="password"
                          className="form-label-smart-city"
                        >
                          Confirm Password
                        </label>
                        <div className="inner-addon right-addon right-addon-button">
                          <input
                            type={hidden ? 'password' : 'text'}
                            placeholder="Confirm Password"
                            onChange={handleOnChange}
                            value={
                              _.get(formData, 'password_confirmation') || ''
                            }
                            name="password_confirmation"
                            id="loginPassword"
                            className="form-control form-control-lg form-control-icon"
                            style={{
                              border: '1px solid #D3D3D3',
                              borderRadius: '8px',
                            }} // smart-city
                          />
                          <button
                            type="button"
                            tabIndex={-1}
                            className="btn btn-right"
                            onClick={() => setHidden(!hidden)}
                          >
                            {hidden ? <IconEyeOn /> : <IconEyeOff />}
                          </button>
                        </div>
                      </div>
                      {/* <div className="form-helpers action">
                      <Link to="/forgot-password" className="link-action">
                        Forgot Password?
                      </Link>
                    </div> */}
                      <div className="pt-2">
                        <button
                          type="submit"
                          disabled={isLoading}
                          className="btn btn-dark btn-outline-dark btn-block btn-signin"
                          style={{
                            cursor: isLoading ? 'not-allowed' : 'pointer',
                            borderRadius: '8px',
                            fontWeight: 600,
                          }}
                        >
                          {isLoading && (
                            <i className="fas fa-spin fa-spinner" />
                          )}{' '}
                          Submit
                        </button>
                      </div>
                    </form>
                    <div className="row">
                      <div className="col-md-12 d-flex justify-content-center mt-3 text-muted">
                        <small>{APP_VERSION}</small>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="ilgu-icon col-12">
            <div className="ilgu-icon-cont">
              <div className="cms-text-primary"> Developed by: </div>
              <div>
                <img
                  // className="ilgu-icon-img"
                  alt=""
                  src={
                    _.get(CMS_LOGO, 'FOOTER_LOGO_CORE.cdnUrl') ||
                    _.get(CMS_LOGO, 'FOOTER_LOGO_CORE')
                  }
                  width={130}
                  height={88}
                />
              </div>
            </div>
          </div>
        </div>

        {/* <div className="fixed-bottom text-right">
          <button
            type="button"
            className="btn btn-link text-dark"
            onClick={handleAddModal}
          >
            +
          </button>
          <button
            type="button"
            className="btn btn-link text-dark"
            onClick={handleEditModal}
          >
            -
          </button>
          <button
            type="button"
            className="btn btn-link text-dark"
            onClick={handleSelectModal}
          >
            /
          </button>
        </div> */}
      </div>
    </div>
  );
}

// ResetPassword.defaulProps = {
//   enableProfile: {},
// }

ResetPassword.propTypes = {
  resetPassword: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  mfaLogin: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: api.loading.indexOf(c.RESET_PASSWORD) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ResetPassword);
